import { PriceActions, PriceActionTypes } from "actions";
import { IPrice } from "sagas/priceSaga";

interface PriceState {
  price: IPrice;
  loading: boolean;
  error: string | null;
}

const initialState: PriceState = {
  price: {
    price: 0,
    volume_24h: 0,
    volume_change_24h: 0,
    percent_change_1h: 0,
    percent_change_24h: 0,
    percent_change_7d: 0,
    percent_change_30d: 0,
    percent_change_60d: 0,
    percent_change_90d: 0,
    market_cap: 0,
    market_cap_dominance: 0,
    fully_diluted_market_cap: 0,
    tvl: undefined,
    last_updated: ""
  },
  loading: false,
  error: null,
};

const priceReducer = (
  state = initialState,
  action: PriceActions
): PriceState => {
  switch (action.type) {
    case PriceActionTypes.FETCH_PRICE_REQUEST:
      return { ...state, loading: true, error: null };
    case PriceActionTypes.FETCH_PRICE_SUCCESS:
      return { ...state, loading: false, price: action.payload };
    case PriceActionTypes.FETCH_PRICE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default priceReducer;
